import { logoutURL } from '../constants/urls'

export const cerrarSesion = (logout, destino = logoutURL) => {
  logout()
  window.location.href = destino
}
